import React from 'react';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
export const DragList = ({ items, isTouch }) => {
    return (React.createElement(DndProvider, { backend: TouchBackend, options: { enableMouseEvents: true } }, items));
};
